/**
 * Rules fingerprint — a short digest of the rules a replay depends on, saved with replay files
 * (the film archive) so a record made under other rules can be flagged *before* it is played.
 *
 * It covers every balance table and constant in core/constants.ts plus the replay format
 * version: any balance change alters it. Changes to the systems' code are not covered — the
 * replay's end-state check (`ReplaySession.matchesRecording`, the "Record verified / diverges"
 * seal) remains the authority on whether a film reproduces its war.
 */
import * as rules from '../core/constants';
import { hashText } from '../sim/hash';
import { REPLAY_VERSION } from './log';

let cached: string | null = null;

export function rulesFingerprint(): string {
  if (cached === null) {
    // Sorted keys: bundlers may emulate the module namespace in any order. Functions (helpers
    // such as `isNight`) serialise as null — their code is not part of the fingerprint.
    const table = Object.keys(rules)
      .sort()
      .map((key) => [key, (rules as Record<string, unknown>)[key]]);
    cached = hashText(JSON.stringify({ replay: REPLAY_VERSION, rules: table }));
  }
  return cached;
}
